import styles from './EmptyCartPage.module.scss';

import type { ReferencedEntry } from 'contentful';
import React, { useEffect, FC } from 'react';

import type { SolutionPickerModule as SolutionPickerModuleType } from 'api/contentful/contentTypes.cloverdotcom';
import { SolutionPickerModule } from 'components/SolutionPickerModule/SolutionPickerModule';
import { useSolutionPicker } from 'hooks/useSolutionPicker';
import { SolutionPickerEntryId } from 'api/contentful/solutionPickerEntryIds';
import { EMPTY_CART_PAGE_TEST_ID } from './EmptyCartPage.const';

interface ISolutionsProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<SolutionPickerModuleType>;
}

export const EmptyCartPage: FC<ISolutionsProps> = ({ ...props }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  const entry = useSolutionPicker(SolutionPickerEntryId.EMPTY_CART_PAGE);
  if (!entry) return null;

  const entryWithMetadata: ReferencedEntry<SolutionPickerModuleType> = {
    ...entry,
    fields: { ...entry.fields, headingTagName: 'h1' },
  };

  return (
    <div data-testid={EMPTY_CART_PAGE_TEST_ID.catalog} className={styles.emptyCart}>
      <SolutionPickerModule {...props} entry={entryWithMetadata} />
    </div>
  );
};
EmptyCartPage.displayName = 'EmptyCartPage';
